import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_e0816016-db79-423a-a550-6522d024345b/artifacts/ytf37ld2_t.t.i.%20logo.jpg";
export const PHONE_TEL = "tel:+13372354923";
export const PHONE_DISPLAY = "337-235-4923";

export function LiveDot() {
  return (
    <span className="relative flex h-2 w-2">
      <span className="live-dot relative inline-flex h-2 w-2 rounded-full bg-uv" />
    </span>
  );
}

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
      className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-machine/70 backdrop-blur-xl"
      data-testid="site-nav"
    >
      <div className="mx-auto flex h-16 w-full max-w-[1700px] items-center justify-between px-4 sm:h-20 sm:px-6 lg:px-10">
        <a href="#top" data-testid="nav-logo-link" className="group flex items-center gap-3">
          <span className="frame-chamfer-sm inline-block bg-white px-3 py-1.5 transition-transform duration-300 group-hover:-translate-y-0.5">
            <img src={LOGO_URL} alt="Tube Tech Services INC" className="h-6 w-auto sm:h-8" />
          </span>
          <span className="hidden font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400 md:block">
            Church Point, LA
          </span>
        </a>

        <div className="flex items-center gap-5">
          <span
            data-testid="nav-open-badge"
            className="hidden items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400 sm:flex"
          >
            <LiveDot />
            Open 24/7 — 365
          </span>
          <a
            href={PHONE_TEL}
            data-testid="nav-call-button"
            className="group flex items-center gap-2.5 border border-white/15 bg-white/[0.03] px-4 py-2.5 font-mono text-xs tracking-[0.15em] text-slate-100 transition-colors duration-300 hover:border-uv/60 hover:bg-uv/10 hover:text-uv sm:px-5"
          >
            <Phone className="h-3.5 w-3.5 transition-transform duration-300 group-hover:rotate-12" />
            <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
            <span className="sm:hidden">CALL</span>
          </a>
        </div>
      </div>
    </motion.header>
  );
}
